// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondary {
  background: rgb(255, 255, 255);
  border-radius: 5px;
  outline: none;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.331373px;
  color: var(--theme-main-color, #055C8D);
  border: 1px solid var(--theme-main-border-color, #055C8D);
  width: -moz-fit-content;
  width: fit-content;
  height: 34px;
  white-space: nowrap;
  min-width: 80px;
}

.secondary:hover {
  /* background: var(--theme-main-background-color, #055C8D); */
  background: var(--theme-active-color, #055C8D);
  color: #FFF;
  border: 1px solid #FFF;
}

button.focus {
  outline: 0 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
